import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/** Pantalla de proceso (077): solo indicador + texto corto, sobre bg/canvas con el logo arriba. */
@Component({
  selector: 'app-process-screen',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <app-brand class="brand" />
    <div class="box" role="status" aria-live="polite">
      <span class="cr-spinner cr-spinner--36"></span>
      <p>{{ text() }}</p>
    </div>
  `,
  styles: [`
    :host{position:fixed;inset:0;z-index:var(--cr-z-process);background:var(--cr-bg-canvas);display:grid;place-items:center}
    .brand{position:absolute;left:40px;top:20px}
    .box{display:flex;flex-direction:column;align-items:center;gap:18px;padding:8px 0}
    p{margin:0;font:700 24px/28px var(--cr-font-display);letter-spacing:-.24px}
    @media (max-width:640px){ .brand{left:16px;top:16px} }
  `],
})
export class ProcessScreenComponent {
  readonly text = input<string>('Cargando…');
}
